/*
 * MDB shim for MDBCardFooter
 * Files currently importing this symbol from "mdbreact":
 * - src/Components/Custom/InlineTable.jsx
 * - src/Seating/Faxes/faxes.jsx
 */

import MUIBox from "@mui/material/Box";

export default function MDBCardFooter({ children, className, style, ...rest }) {
    return (
        <MUIBox className={className} style={style} {...rest}>
            {children}
        </MUIBox>
    );
}
